import { render, staticRenderFns } from "./ExportDistributionList.vue?vue&type=template&id=4d8c825c&"
import script from "./ExportDistributionList.vue?vue&type=script&lang=js&"
export * from "./ExportDistributionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports